import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme = () => ({
    flex: 1,

    display: 'flex',
    flexDirection: 'column',

    width: '100%',
    maxWidth: '33.75rem',

    overflow: 'auto',

    paddingTop: '1rem',
    paddingRight: '1.5rem',
    paddingBottom: '2.5rem',
    paddingLeft: '1.5rem',

    min1440: {
        paddingTop: '3.75rem',
    },
});

export const title: TRuleWithTheme = () => ({
    marginBottom: '1.25rem',
});

export const settingsPane: TRuleWithTheme = ({ theme }) => ({
    backgroundColor: theme.colors.backgroundsSecondary,
    borderRadius: '0.25rem',
});
